function RouteModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.routes = ctrl.resolve.routes;
    ctrl.mode = ctrl.resolve.mode;
  };

  ctrl.selectRoute = ($event, route) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (ctrl.selectedRoute === route) {
      ctrl.selectedRoute = null;
    } else {
      ctrl.selectedRoute = route;
      let start = _.head(ctrl.selectedRoute.stations);
      let end = _.last(ctrl.selectedRoute.stations);
      ctrl.selectedRoute.reversedName = `${end.name} to ${start.name}`;
    }
  };

  ctrl.submit = mode => {
    if (mode === 'default') {
      ctrl.close({ $value: ctrl.selectedRoute });
    } else if (mode === 'reverse') {
      ctrl.selectedRoute.name = ctrl.selectedRoute.reversedName;
      ctrl.selectedRoute.stations.reverse();
      ctrl.selectedRoute.reverse = true;
      ctrl.close({ $value: ctrl.selectedRoute });
    }
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('RouteModalController', RouteModalController);
